import type { TranslateDictionary } from './en.js';

export const Hu: TranslateDictionary = {
  'Start airplay': 'AirPlay indítása',
  'Stop airplay': 'AirPlay leállítása',
  Audio: 'Hang',
  Captions: 'Feliratok',
  'Enable captions': 'Feliratok bekapcsolása',
  'Disable captions': 'Feliratok kikapcsolása',
  'Start casting': 'Közvetítés indítása',
  'Stop casting': 'Közvetítés leállítása',
  'Casting to {device}': 'Átküldés a(z) {device} eszközre',
  'Enter fullscreen mode': 'Teljes képernyő',
  'Exit fullscreen mode': 'Kilépés a teljes képernyőből',
  Mute: 'Némítás',
  Unmute: 'Visszahangosítás',
  'Enter picture in picture mode': 'Kép a képben mód bekapcsolása',
  'Exit picture in picture mode': 'Kép a képben mód kikapcsolása',
  Play: 'Lejátszás',
  Pause: 'Megállítás',
  'Playback rate': 'Lejátszási sebesség',
  'Playback rate {playbackRate}': 'Lejátszási sebesség {playbackRate}',
  Quality: 'Minőség',
  'Seek backward': 'Visszatekerés',
  'Seek forward': 'Előretekerés',
  Settings: 'Beállítások',
  Auto: 'Automatikus',
  'audio player': 'hanglejátszó',
  'video player': 'videolejátszó',
  volume: 'Hangerő',
  seek: 'Keresés',
  'closed captions': 'Feliratok',
  'current playback rate': 'aktuális lejátszási sebesség',
  'playback time': 'lejátszási idő',
  'media loading': 'média betöltése',
  settings: 'Beállítások',
  'audio tracks': 'hangsávok',
  quality: 'Minőség',
  play: 'lejátszás',
  pause: 'megállítás',
  mute: 'némítás',
  unmute: 'visszahangosítás',
  'chapter: {chapterName}': 'fejezet: {chapterName}',
  live: 'élő',
  Off: 'Ki',
  'start airplay': 'AirPlay indítása',
  'stop airplay': 'AirPlay leállítása',
  'start casting': 'közvetítés indítása',
  'stop casting': 'közvetítés leállítása',
  'enter fullscreen mode': 'teljes képernyő',
  'exit fullscreen mode': 'kilépés a teljes képernyőből',
  'enter picture in picture mode': 'kép a képben mód bekapcsolása',
  'exit picture in picture mode': 'kép a képben mód kikapcsolása',
  'seek to live': 'ugrás az élő közvetítésre',
  'playing live': 'élő lejátszás',
  'seek back {seekOffset} seconds': 'visszatekerés {seekOffset} másodperccel',
  'seek forward {seekOffset} seconds': 'előretekerés {seekOffset} másodperccel',
  'Network Error': 'Hálózati hiba',
  'Decode Error': 'Dekódolási hiba',
  'Source Not Supported': 'A forrás nem támogatott',
  'Encryption Error': 'Titkosítási hiba',
  'A network error caused the media download to fail.':
    'Hálózati hiba miatt a média letöltése sikertelen volt.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Egy médiahibа miatt a lejátszás megszakadt. A média sérült lehet, vagy a böngésző nem támogatja ezt a formátumot.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Nem támogatott hiba történt. A szerver vagy a hálózat meghibásodott, vagy a böngésző nem támogatja ezt a formátumot.',
  'The media is encrypted and there are no keys to decrypt it.':
    'A média titkosított, és nincsenek kulcsok a visszafejtéshez.',
};
